var $ = jQuery;

import { carousel } from '../lib/carousel.js';

// Travel diaries on the home page.
$(document).on('ready', function(){
    $('.blog-swiper').each(function(){
      carousel(this, this.parentElement, {
        label: 'article',
        slidesPerView: 1.3,
        spaceBetween: 16,
        breakpoints: {
          500: { slidesPerView: 2, spaceBetween: 20 },
          1400: { slidesPerView: 2.5, spaceBetween: 20 },
        },
      });
    });
  });
